module.exports = __webpack_public_path__ + "img/history_timeline_1.c5c09523.png";